import { inject, Injectable } from "@angular/core";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { LoginPromptContext, LoginPromptDialogComponent } from "./login-prompt-dialog.component";

@Injectable({ providedIn: "root" })
export class LoginPromptService {
  private readonly dialogService = inject(DialogService);

  /** @param context "cart" for the cart flow, "generic" for browsing actions. */
  openLoginRequired(context: LoginPromptContext = "generic"): DynamicDialogRef {
    return this.dialogService.open(LoginPromptDialogComponent, {
      data: { context },
      width: "40vw",
      breakpoints: {
        "960px": "75vw",
        "640px": "90vw",
      },
      dismissableMask: true,
      closable: true,
    });
  }
}
